// src/routes/PageRender.jsx

import About from "../../pages/AboutPage/page/About";
import AboutLanding from "../../pages/AboutPage/page/AboutLanding";
import AboutMilestone from "../../pages/AboutPage/page/AboutMilestone";
import AboutPartner from "../../pages/AboutPage/page/AboutPartner";
import CareerLanding from "../../pages/CareerPage/page/CareerLanding";

import Franchise from "../../pages/FranchisePage/page/Franchise";
import GeneralPage from "../../pages/GeneralPage/Page/generalPage";

import TestPreparation from "../../pages/TestPreparationPage/page/TestPreparation";

const PAGE_TYPE_COMPONENT = {
  4: TestPreparation,
  5: AboutMilestone, //milestone

  7: GeneralPage,

  9: About,
  12: AboutLanding, //who we are
  13: AboutMilestone,
  14: AboutPartner, //partnership
  15: About, //ceo
  16: CareerLanding,
  17: Franchise,
};

const ThemeRenderer = ({ pageData }) => {
  console.log("Resolved page:", pageData);

  const Component = PAGE_TYPE_COMPONENT[pageData?.pageType] || GeneralPage;

  return <Component pageData={pageData} />;
};

export default ThemeRenderer;
